const LightBulb = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 512 512">
      <path
        d="M304,384V360c0-29,31.54-56.43,52-76,28.84-27.57,44-64.61,44-108,0-80-63.73-144-144-144A143.6,143.6,0,0,0,112,176c0,41.84,15.81,81.39,44,108,20.35,19.21,52,46.7,52,76v24"
        fill="none"
        stroke="#B54708"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32px"
      />
      <line
        x1="224"
        y1="480"
        x2="288"
        y2="480"
        fill="none"
        stroke="#B54708"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32px"
      />
      <line
        x1="208"
        y1="432"
        x2="304"
        y2="432"
        fill="none"
        stroke="#B54708"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32px"
      />
      <line
        x1="256"
        y1="384"
        x2="256"
        y2="256"
        fill="none"
        stroke="#B54708"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32px"
      />
      <path
        d="M294,240s-21.51,16-38,16-38-16-38-16"
        fill="none"
        stroke="#B54708"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="32px"
      />
    </svg>
  );
};

export default LightBulb;
